var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"birthday"},[_c('slick',{ref:"slick",attrs:{"options":_vm.slickOptions}},_vm._l((_vm.birthdays),function(birthday,index){return _c('birthday-item',{key:index,attrs:{"image":birthday.image,"name":birthday.name}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3145df2e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Birthday.vue
// module id = null
// module chunks = 